import { type CollectionStoreSummaryResponse } from '@Src/types/collectionStoreTypes';
import Cookies from 'js-cookie';

const baseUrl = 'https://api.flipdish.co';

const getCollectionStoreSummaries = async (
  appId: string,
  lat: number,
  lng: number,
  version?: string,
): Promise<CollectionStoreSummaryResponse> => {
  const headers = {
    'Content-Type': 'application/json',
    'Flipdish-App-Type': 'Web',
    'Flipdish-App-Version': version || '',
    'Flipdish-White-Label-Id': appId,
    'X-Flipdish-Token': Cookies?.get('flipdish-token') || '',
  };

  const response = await fetch(
    `${baseUrl}/Restaurant/PickupPhysicalRestaurantSummariesFromCoordinates?latitude=${lat}&longitude=${lng}&count=50&skip=0`,
    {
      method: 'GET',
      headers,
    },
  );
  return await response.json();
};

export { getCollectionStoreSummaries };
